export interface PreferenceState {
  cookiesAccepted: boolean;
}

export const DISMISS_COOKIES = 'DISMISS_COOKIES';
